export enum DynamicFormElementType {
  ARRAY = 'ARRAY',
  GROUP = 'GROUP',
  FIELD = 'FIELD',
}
